module.exports = __webpack_public_path__ + "static/img/activity-arrow.67d94d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/activity-arrow.png
// module id = 25ml
// module chunks = 34